export default class ReportController
{
	constructor($scope, $http, $route, $location, AppService, DateRangeService, DataTableService, ChartService) {
		// Dependancies
		this.$scope = $scope;
		this.$http = $http;
		this.$route = $route;
		this.AppService = AppService;
		this.DateRangeService = DateRangeService;
		this.DataTableService = DataTableService;
		this.ChartService = ChartService;

		this.topTenEndPoint = ['country', 'accommodation', 'transport', 'airline', 'organisation-groups', 'organisation-pax'];

		// Set page title
		this.$scope.$parent.title = this.title;

		// Set page endpoint
		this.$scope.$parent.endpoint = this.endpoint;

		// Register events
		this.$scope.$on('base-range-update', () => { this.updateBaseData() });
		this.$scope.$on('compare-range-update', () => { this.updateCompareData() });
		this.$scope.$on('all-range-update', () => { this.updateData() });

		// Initialising chart renderers
		this.ChartService.create('chart');

		if ($('#overview-chart').length) {
			this.ChartService.createOverview('overview-chart');
		}

		this.baseData = null;

		this.updateData();
	}

	setPeriod(period) {
		if (period !== this.AppService.period) {
			this.AppService.period = period;
			this.updateData();
		}
	}

	toggleTopTen() {
		if (this.AppService.limit == false) {
			this.AppService.limit = 10;
		} else {
			this.AppService.limit = false;
		}
		this.updateData();
		if (this.AppService.compare) {
			this.$route.reload();
		}
	}

	updateData() {
		this.updateBaseData();
	}

	updateBaseData() {
		this.getDataFromApi(
			this.endpoint,
			this.DateRangeService.startDate.format('YYYY-MM-DD'),
			this.DateRangeService.endDate.format('YYYY-MM-DD'),
			(body) => {
				this.baseData = body.data;
				this.ChartService.updateBaseData(body.data);
				this.DataTableService.updateBaseData(body.data);
				if (this.AppService.compare) {
					this.updateCompareData();
				}
			}
		);
	}

	updateCompareData() {
		this.getDataFromApi(
			this.endpoint,
			this.DateRangeService.compareStartDate.format('YYYY-MM-DD'),
			this.DateRangeService.compareEndDate.format('YYYY-MM-DD'),
			(body) => {
				this.ChartService.updateCompareData(body.data);
				this.DataTableService.updateCompareData(body.data);
			}
		);
	}

	getDataFromApi(endpoint, startDate, endDate, callback) {

		if (this.topTenEndPoint.includes(endpoint)) {
			var params = {
				start_date: startDate,
				end_date: endDate,
				period: this.AppService.period,
				limit: this.AppService.limit
			}
		} else {
			var params = {
				start_date: startDate,
				end_date: endDate,
				period: this.AppService.period
			}
		}

		this.$http({
			method: 'GET',
			url: '/api/'+endpoint,
			params: params,
			async: false,
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(
			(response) => {
				callback(response.data);
			},
			(response) => {
				alert('Unable to get report data');
				console.log(response);
			}
		);
	}

	getOverviewData(category) {
		this.getOverviewDataFromApi(
			this.endpoint,
			category,
			this.DateRangeService.startDate.format('YYYY-MM-DD'),
			this.DateRangeService.endDate.format('YYYY-MM-DD'),
			(body) => {
				this.ChartService.updateOverviewBaseData(body.data);
			}
		);

		if (this.AppService.compare) {
			this.getOverviewDataFromApi(
				this.endpoint,
				category,
				this.DateRangeService.compareStartDate.format('YYYY-MM-DD'),
				this.DateRangeService.compareEndDate.format('YYYY-MM-DD'),
				(body) => {
					this.ChartService.updateOverviewCompareData(body.data);
				}
			);
		}
	}

	getOverviewDataFromApi(endpoint, category, startDate, endDate, callback) {
		this.$http({
			method: 'GET',
			url: '/api/'+endpoint+'/overview',
			params: {
				category: category,
				start_date: startDate,
				end_date: endDate,
				period: this.AppService.period
			},
			async: false,
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(
			(response) => {
				callback(response.data);
			},
			(response) => {
				alert('Unable to get overview report data');
				console.log(response);
			}
		);
	}

	getDifference(volume, compareVolume) {
		return (volume - compareVolume) || 0;
	}

	getDifferencePercent(volume, compareVolume) {
		return +(this.getDifference(volume, compareVolume) / volume * 100).toFixed(2) || 0;
	}
}

// Hack for angular and since you can't set class attributes in ECMA6
// I even tried setting it as a getter
ReportController.$inject = [
	'$scope',
	'$http',
	'$route',
	'$location',
	'AppService',
	'DateRangeService',
	'DataTableService',
	'ChartService'
]



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/report.controller.js
 **/